export { IconWithText } from './icon-with-text'
